import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-footer2',
  templateUrl: './footer2.component.html',
  styleUrls: ['./footer2.component.scss']
})
export class Footer2Component implements OnInit {

  @Input() footer2Type:string;

  constructor() { }

  ngOnInit(): void {
  }

}
